import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "common-horizontal-recipe-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonHorizontalRecipeListItem = _resolveComponent("CommonHorizontalRecipeListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getRecipes(_ctx.recipes), (recipe) => {
      return (_openBlock(), _createBlock(_component_CommonHorizontalRecipeListItem, {
        class: "common-horizontal-recipe-list-item",
        key: recipe.recipeId,
        recipeImageUrl: recipe.imageUrl,
        recipeLabel: recipe.title,
        isFoods: _ctx.isFoods,
        onOnClick: ($event: any) => (_ctx.selectRecipe(recipe.recipeId, recipe.type))
      }, null, 8, ["recipeImageUrl", "recipeLabel", "isFoods", "onOnClick"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}